import * as React from "react";
import {none, option, Option} from "ts-option";
import {BillOfMaterialsPreviewDetails} from "../../../../model/job/BillOfMaterialsPreviewDetails";
import QuoteDetails from "../../../../model/quote/QuoteDetails";
import BillOfMaterialsPrices from "../BillOfMaterialsPrices";
import Price, {CurrencyIsoCode} from "../../../../model/common/Price";
import "../../../accounting/common/commonDetailsInfoRow.scss";
import {Bom} from "../../../../model/job/Bom";
import classNames = require("classnames");

interface ComponentProps {
	/**
	 * Details of quote
	 */
	quoteDetails: Option<QuoteDetails>
	/**
	 * Bill of materials details
	 */
	billOfMaterialsDetails: BillOfMaterialsPreviewDetails | Bom
}

export default class JobBillOfMaterialsDetailsSummary extends React.PureComponent<ComponentProps> {

	render() {
		const bomDetails = this.props.billOfMaterialsDetails;
		const total = bomDetails.total.map(total => total.format()).getOrElse("-");
		const parts = bomDetails.profit.parts.map(parts => parts.format()).getOrElse("-");
		const margin = bomDetails.profit.margin.format();
		const rebate = bomDetails.profit.rebate.format();
		const sum = bomDetails.profit.sum.map(sum => sum.format()).getOrElse("-");
		const sumAsNumber = bomDetails.profit.sum.map(sum => sum.amount).orNull;
		const classesForSum = classNames({
			"c-common-info_row-item_value-large": true,
			"t-green-color": sumAsNumber > 0,
			"has-error": sumAsNumber < 0
		});
		let customerPrice = none, installerEarnings = none;
		if (bomDetails instanceof Bom) {
			customerPrice = option(bomDetails.customerPrice);
			installerEarnings = bomDetails.installerEarnings;
		}
		else {
			this.props.quoteDetails.map(quote => {
				customerPrice = option(new Price(quote.totalPrice.cents / 100, CurrencyIsoCode.GBP));
				installerEarnings = option(new Price(quote.getInstallerGross().cents / 100, CurrencyIsoCode.GBP));
			});
		}

		return (
			<div className="c-common-info_row-container">
				<div className="c-common-info_row-inner-container">
					<BillOfMaterialsPrices customerPrice={customerPrice}
										   installerEarnings={installerEarnings}/>
					<div className="job-bill-of-materials_info-row-narrow-item_with-separation">
						<div className="c-common-info_row-item_value-large">{parts}</div>
						<div className="c-common-info_row-item_label-bottom">Parts profit</div>
					</div>
					<div className="job-bill-of-materials_info-row-narrow-item">
						<div className="c-common-info_row-item_value-large t-blue-medium">+</div>
					</div>
					<div className="job-bill-of-materials_info-row-narrow-item">
						<div className="c-common-info_row-item_value-large">{margin}</div>
						<div className="c-common-info_row-item_label-bottom">Margin</div>
					</div>
					<div className="job-bill-of-materials_info-row-narrow-item">
						<div className="c-common-info_row-item_value-large t-blue-medium">+</div>
					</div>
					<div className="job-bill-of-materials_info-row-narrow-item">
						<div className="c-common-info_row-item_value-large">{rebate}</div>
						<div className="c-common-info_row-item_label-bottom">Total rebate</div>
					</div>
					<div className="job-bill-of-materials_info-row-narrow-item">
						<div className="c-common-info_row-item_value-large t-blue-medium">=</div>
					</div>
					<div className="c-common-info_row-item">
						<div className={classesForSum}>{sum}</div>
						<div className="c-common-info_row-item_label-bottom">Job Profit</div>
					</div>
					<div className="job-bill-of-materials_info-row-narrow-item_with-separation">
						<div className="c-common-info_row-item_value-large">{total}</div>
						<div className="c-common-info_row-item_label-bottom">Order total</div>
					</div>
				</div>
			</div>
		);
	}
}
